// extracted by mini-css-extract-plugin
var _1 = "Popup_closeButton__LQ+BJ";
var _2 = "Popup_popup__SxMIp";
var _3 = "Popup_popupFadeIn__Ykf0h";
export { _1 as "closeButton", _2 as "popup", _3 as "popupFadeIn" }
